import { Component, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { SqlService } from '../../Database/sql.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-view-direct-boxes',
  templateUrl: './view-direct-boxes.component.html',
  styleUrls: ['./view-direct-boxes.component.css'],
})
export class ViewDirectBoxesComponent implements OnInit {
  closeResult = '';
  DisplayErrormessage = '';
  PopupTitle = '';

  SearchValue = {
    Boxno: '',
    Provider: 'All',

    Supervisor: 'All',

    SerialNumber: 'All',

    AgentName: '',
    ConnectionStartDate: '',
    ConnectionEndDate: '',

    ActivationStartDate: '',
    ActivationEndDate: '',

    DateIssuedToAgentStartDate: '',
    DateIssuedToAgentEndDate: '',

    DateAllocatedToSupervisorStartDate: '',
    DateAllocatedToSupervisorEndDate: '',
  };

  Providers = [''];
  Supervisors = [''];

  Agents = [''];
  AgentsName = [''];

  data = [
    {
      Boxno: '',
      BrickNumber: '',
      Serialno: '',
      Provider: '',
      DateReceived: '',

      Branch: '',
      Supervisor: '',
      AgentName: '',
      CellNo: '',
      uCode: '',
      DateIssuedToSupervisor: '',
      DateIssuedToAgent: '',

      Connection: '',
      Activation: '',
      AgentArea: '',
      AgentProvince: '',
    },
  ];

  p: number = 1;
  ItemsPerPage = 20;

  Amount = 0;

  iRowsLoaded = 0;

  constructor(
    private dbService: SqlService,
    private router: Router,
    private modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.clearData();
    this.getData();
    this.getAllAgents();
    this.getAllProvidersDistributors();
  }

  clearData() {
    this.iRowsLoaded = 0;
    this.data = [];
  }

  LoadMoreFields() {
    this.getData();
  }

  getAllAgents() {
    Swal.fire({
      title: 'Loading list of Agents.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, // Prevents closing on outside click
      allowEscapeKey: false, // Prevents closing on Esc key
      willOpen: () => {
        Swal.showLoading();
      },
    });

    this.Agents.pop();
    this.AgentsName.pop();

    this.dbService.getAllAgents().subscribe((ret: any) => {
      if (ret != 'false') {
        this.Agents.splice(0);
        this.AgentsName.splice(0);

        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach((element) => {
          let elementtemp = element.split(',');
          let temp = {
            Name: elementtemp[0],
            Surname: elementtemp[1],
            CellNo: elementtemp[2],
            ID: elementtemp[3],
            Code: elementtemp[4],
          };
          this.Agents.push(temp.Code);
          this.AgentsName.push('-' + temp.Name + ' ' + temp.Surname);
        });

        Swal.close();
      } else {
        this.PopupTitle = 'Something went wrong while loading list of agents.';
        this.DisplayErrormessage =
          'Please check your internet connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }

  getAllProvidersDistributors() {
    this.Providers = [];
    this.Supervisors = [];

    Swal.fire({
      title: 'Loading list of providers.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, // Prevents closing on outside click
      allowEscapeKey: false, // Prevents closing on Esc key
      willOpen: () => {
        Swal.showLoading();
      },
    });

    this.dbService.getAllProviders().subscribe((ret: any) => {
      if (ret != 'false') {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach((element) => {
          let elementtemp = element.split(',');
          let temp = {
            ID: elementtemp[0],
            BoxSize: elementtemp[1],//BoxSizeDirect
            BatchSize: elementtemp[2],//BatchSizeDirect
            // 3 -> BoxSizeInDirect
            // 4 -> BatchSizeInDirect
          };

          this.Providers.push(temp.ID);
        });
        Swal.close();
        Swal.fire({
          title: 'Loading list of distributors.',
          showConfirmButton: false,
          toast: false,
          allowOutsideClick: false, // Prevents closing on outside click
          allowEscapeKey: false, // Prevents closing on Esc key
          willOpen: () => {
            Swal.showLoading();
          },
        });
        this.dbService.getAllDistrubutor().subscribe((ret: any) => {
          if (ret != 'false') {
            let a = (ret as string).split(';');
            a.splice(a.length - 1, 1);

            a.forEach((element) => {
              let elementtemp = element.split(',');
              let temp = {
                ID: elementtemp[0],
                Province: elementtemp[1],
                Active: elementtemp[2],
              };
              this.Supervisors.push(temp.ID);
            });
            Swal.close();
          } else {
            this.PopupTitle =
              'Something went wrong while loading the list of distributors.';
            this.DisplayErrormessage =
              'Please check your internet connection and try again';
            let element: HTMLButtonElement = document.getElementById(
              'ErrorButton'
            ) as HTMLButtonElement;
            element.click();
            Swal.close();
          }
        });
      } else {
        this.PopupTitle =
          'Something went wrong while loading the list of providers.';
        this.DisplayErrormessage =
          'Please check your internet connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }

  getData() {
    Swal.fire({
      title: 'Loading Boxes.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, // Prevents closing on outside click
      allowEscapeKey: false, // Prevents closing on Esc key
      willOpen: () => {
        Swal.showLoading();
      },
    });

    var formData = new FormData(); // Currently empty

    var SQLQuery = '';

    if (this.SearchValue.Boxno != '') {
      SQLQuery += " AND Boxes.Boxno like '" + this.SearchValue.Boxno + "%' ";
    }

    if (this.SearchValue.Provider != 'All') {
      SQLQuery += "AND Boxes.Provider='" + this.SearchValue.Provider + "' ";
    }

    if (this.SearchValue.Supervisor != 'All') {
      SQLQuery +=
        "AND Boxes.Distributor='" + this.SearchValue.Supervisor + "' ";
    }

    if (this.SearchValue.AgentName != '') {
      SQLQuery += "AND Agent.uCode='" + this.SearchValue.AgentName + "' ";
    }

    if (
      this.SearchValue.ConnectionStartDate != '' &&
      this.SearchValue.ConnectionEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.condate between '" +
        this.SearchValue.ConnectionStartDate +
        "' AND '" +
        this.SearchValue.ConnectionEndDate +
        "' ";
    }
    if (
      this.SearchValue.ActivationStartDate != '' &&
      this.SearchValue.ActivationEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.actdate between '" +
        this.SearchValue.ActivationStartDate +
        "' AND '" +
        this.SearchValue.ActivationEndDate +
        "' ";
    }

    if (
      this.SearchValue.DateIssuedToAgentStartDate != '' &&
      this.SearchValue.DateIssuedToAgentEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.DateIssuedToAgent between '" +
        this.SearchValue.DateIssuedToAgentStartDate +
        "' AND '" +
        this.SearchValue.DateIssuedToAgentEndDate +
        "' ";
    }

    if (
      this.SearchValue.DateAllocatedToSupervisorStartDate != '' &&
      this.SearchValue.DateAllocatedToSupervisorEndDate != ''
    ) {
      SQLQuery +=
        " AND Boxes.DateIssuedToSupervisor between '" +
        this.SearchValue.DateAllocatedToSupervisorStartDate +
        "' AND '" +
        this.SearchValue.DateAllocatedToSupervisorEndDate +
        "' ";
    }

    formData.set('SQLQuery', SQLQuery);
    formData.set('start', this.iRowsLoaded.toString());
    this.iRowsLoaded += 200;
    formData.set('end', this.iRowsLoaded.toString());

    this.dbService.getAllDirectBoxes(formData).subscribe((ret: any) => {
      if (ret != 'false') {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach((element) => {
          let elementtemp = element.split(',');
          // $row['']  ."," . $row['']  ."," . $row[''].";";

          let temp = {
            Boxno: elementtemp[0],
            BrickNumber: elementtemp[1],

            Serialno: elementtemp[2] + ',',
            Provider: elementtemp[3],
            DateReceived: elementtemp[4],
            Branch: elementtemp[5],
            Supervisor: elementtemp[6],

            AgentName: elementtemp[7],
            CellNo: elementtemp[8],

            uCode: elementtemp[9],
            DateIssuedToSupervisor: elementtemp[10],
            DateIssuedToAgent: elementtemp[11],

            Connection: elementtemp[12],
            Activation: elementtemp[13],
            AgentArea: elementtemp[14] ? elementtemp[14] : '',
            AgentProvince: elementtemp[15] ? elementtemp[15] : '',
          };

          this.data.push(temp);
        });
        Swal.close();
      } else {
        this.PopupTitle = 'Something went wrong while loading boxes.';
        this.DisplayErrormessage =
          'Please check your internet connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }

  ViewData(AreaID: string) {
    this.router.navigate(['/ViewSpecificBox', AreaID]);
  }

  ClearSearch() {
    this.SearchValue = {
      Boxno: '',
      Provider: 'All',
      Supervisor: 'All',

      SerialNumber: 'All',
      ConnectionStartDate: '',
      ConnectionEndDate: '',

      ActivationStartDate: '',
      ActivationEndDate: '',

      DateIssuedToAgentStartDate: '',
      DateIssuedToAgentEndDate: '',
      DateAllocatedToSupervisorStartDate: '',
      DateAllocatedToSupervisorEndDate: '',

      AgentName: '',
    };

    this.clearData();
    this.getData();
  }

  ClearBoxNoSearch() {
    this.SearchValue.Boxno = '';
    this.Search();
  }

  Search() {
    Swal.fire({
      title: 'Searching for box.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, // Prevents closing on outside click
      allowEscapeKey: false, // Prevents closing on Esc key
      willOpen: () => {
        Swal.showLoading();
      },
    });
    this.clearData();
    this.getData();
  }

  async btnDownloadReportClickExcel() {
    var formData = new FormData(); // Currently empty

    var SQLQuery = '';

    if (this.SearchValue.Boxno != '') {
      SQLQuery += " AND Boxes.Boxno like '~" + this.SearchValue.Boxno + "%' ";
    }

    if (this.SearchValue.Provider != 'All') {
      SQLQuery += "AND Boxes.Provider='" + this.SearchValue.Provider + "' ";
    }

    if (this.SearchValue.Supervisor != 'All') {
      SQLQuery +=
        "AND Boxes.Distributor='" + this.SearchValue.Supervisor + "' ";
    }

    if (this.SearchValue.AgentName != '') {
      SQLQuery += "AND Agent.uCode='" + this.SearchValue.AgentName + "' ";
    }

    if (
      this.SearchValue.ConnectionStartDate != '' &&
      this.SearchValue.ConnectionEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.condate between '" +
        this.SearchValue.ConnectionStartDate +
        "' AND '" +
        this.SearchValue.ConnectionEndDate +
        "' ";
    }
    if (
      this.SearchValue.ActivationStartDate != '' &&
      this.SearchValue.ActivationEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.actdate between '" +
        this.SearchValue.ActivationStartDate +
        "' AND '" +
        this.SearchValue.ActivationEndDate +
        "' ";
    }

    if (
      this.SearchValue.DateIssuedToAgentStartDate != '' &&
      this.SearchValue.DateIssuedToAgentEndDate != ''
    ) {
      SQLQuery +=
        " AND BoxDetails.DateIssuedToAgent between '" +
        this.SearchValue.DateIssuedToAgentStartDate +
        "' AND '" +
        this.SearchValue.DateIssuedToAgentEndDate +
        "' ";
    }

    if (
      this.SearchValue.DateAllocatedToSupervisorStartDate != '' &&
      this.SearchValue.DateAllocatedToSupervisorEndDate != ''
    ) {
      SQLQuery +=
        " AND Boxes.DateIssuedToSupervisor between '" +
        this.SearchValue.DateAllocatedToSupervisorStartDate +
        "' AND '" +
        this.SearchValue.DateAllocatedToSupervisorEndDate +
        "' ";
    }

    var formData = new FormData();
    formData.set('SQLQuery', SQLQuery);

    //this.http.post(this.Link + 'getAllClientsForView.php',frmData);
    let Link = '';
    if(this.document.location.hostname.includes('admin.pactel.co.za')){
      Link = "https://admin.pactel.co.za/xdt/assets/php/";
    }else{
      Link = 'http://10.10.10.2/xdt/assets/php/';
    }
    window.open(
      Link + "exportDirectData.php?SQLQuery=" +
      SQLQuery
    );
    //this.dbService.ExportAllDirectBoxes(formData)
  } //https://github.com/mk-j/PHP_XLSXWriter

  open(content: any) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = 'Closed with: ${result}';
        },
        (reason) => {
          this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
          //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          //element.click();
        }
      );
  }
}
